import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const OrderComplete = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/order-complete/components/OrderCompleteContent'
      )
  ),
  Template: lazy(
    () =>
      import(
        'components/direct-sales/order-complete/components/OrderCompleteTemplate'
      )
  )
};

export default OrderComplete;
